import { render, staticRenderFns } from "./PicaServicesList.vue?vue&type=template&id=8db6c2fa&scoped=true&"
import script from "./PicaServicesList.vue?vue&type=script&lang=js&"
export * from "./PicaServicesList.vue?vue&type=script&lang=js&"
import style0 from "./PicaServicesList.vue?vue&type=style&index=0&id=8db6c2fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db6c2fa",
  null
  
)

export default component.exports